/* @flow */

import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from '../util/prop_types';


export default function withLocationManager(WrappedComponent) {
  return withRouter(
     class extends React.Component {
      constructor(props) {
        super(props);

      }

      static propTypes = {
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        match: PropTypes.object.isRequired,
      }

      _buildLocation = ({lat, lng, zoom, viewId, placeId, seachQuery}, merge ) => {
        const { params } = (merge) ? this.props.match : {};
        const hash = (merge) ? this.props.location.hash : undefined;
        const search = (merge) ? this.props.location.search : undefined;

        let newPath = "";

        if ((viewId || params.viewId) && viewId != false) {
          newPath += `/view/${viewId || params.viewId}`;
        }

        if ((placeId || params.placeId) && placeId !== false) {
          newPath += `/place/${placeId || params.placeId}`;
        }
        else if ((seachQuery || params.seachQuery) && seachQuery !== false) {
          newPath += `/search/${seachQuery || params.seachQuery}`;
        }

        if ((lat || params.lat) && (lng || params.lng) && (zoom || params.zoom)
        && lat !== false && lng !== false && zoom !== false) {
          newPath += `/@${lat || params.lat},${lng || params.lng},${zoom || params.zoom}z`;
        }

        if (newPath == "") {
          newPath = "/";
        }

        return {
          pathname: newPath,
          search,
          hash
        }

        return newPath;
      }

      pushLocation = (newParams, merge = true) => {
        const curLoc = this.props.location;
        const newLoc = this._buildLocation(newParams, merge);

        if (curLoc.pathname != newLoc.pathname || curLoc.search != newLoc.search || curLoc.hash != newLoc.hash) {
          this.props.history.push(newLoc);
        }
      }

      replaceLocation = (newParams, merge = true) => {
        const curLoc = this.props.location;
        const newLoc = this._buildLocation(newParams, merge);

        if (curLoc.pathname != newLoc.pathname || curLoc.search != newLoc.search || curLoc.hash != newLoc.hash) {
          this.props.history.replace(newLoc);
        }
      }

      render() {
        return (
          <WrappedComponent
            {...this.props}
            pushLocation={this.pushLocation}
            replaceLocation={this.replaceLocation} />
        );
      }
    }
  );
}

//export default withRouter(withLocationManager);
